import { render, staticRenderFns } from "./InquiryDetailPage.vue?vue&type=template&id=92210e96"
import script from "./InquiryDetailPage.vue?vue&type=script&lang=js"
export * from "./InquiryDetailPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports